module.exports = __webpack_public_path__ + "media/icons/notification-close-black-f6fb33ee.png";